export default {
  navigation: [
    { name: 'Início', href: '/' },
    { name: 'Serviços', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Sobre', href: '/about' },
    { name: 'Contato', href: '/contact' }
  ],
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ],
  contact: {
    phone: '+41 77 218 45 02',
    email: 'info@alpbuild.ch',
    address: 'Suíça, cantões de Vaud e Genebra',
    whatsapp: '+41772184502',
    workingHours: 'Seg-Sex: 7:00-17:00'
  }
};